import type { RouteObject } from 'react-router-dom';
import AuthGuard from '@/components/feature/AuthGuard';
import AppLayout from '@/components/feature/AppLayout';
import Login from '@/pages/login/page';
import Dashboard from '@/pages/dashboard/page';
import Customers from '@/pages/customers/page';
import CustomerDetail from '@/pages/customers/detail/page';
import Quotes from '@/pages/quotes/page';
import QuoteDetail from '@/pages/quotes/detail/page';
import Projects from '@/pages/projects/page';
import ProjectDetail from '@/pages/projects/detail/page';
import Tasks from '@/pages/tasks/page';
import Purchases from '@/pages/purchases/page';
import Finance from '@/pages/finance/page';
import Service from '@/pages/service/page';
import Calendar from '@/pages/calendar/page';
import Reports from '@/pages/reports/page';
import Files from '@/pages/files/page';
import Settings from '@/pages/settings/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/login', element: <Login /> },
  {
    path: '/',
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'customers', element: <Customers /> },
      { path: 'customers/:id', element: <CustomerDetail /> },
      { path: 'quotes', element: <Quotes /> },
      { path: 'quotes/:id', element: <QuoteDetail /> },
      { path: 'projects', element: <Projects /> },
      { path: 'projects/:id', element: <ProjectDetail /> },
      { path: 'tasks', element: <Tasks /> },
      { path: 'purchases', element: <Purchases /> },
      { path: 'finance', element: <Finance /> },
      { path: 'service', element: <Service /> },
      { path: 'calendar', element: <Calendar /> },
      { path: 'reports', element: <Reports /> },
      { path: 'files', element: <Files /> },
      { path: 'settings', element: <Settings /> },
    ],
  },
  { path: '*', element: <NotFound /> },
];

export default routes;